import type { RegionalUser } from '../types/user.type'

export function resolveKnownRegionalData(
  fetched: RegionalUser | null | undefined,
  stored: RegionalUser | null | undefined
): RegionalUser | null {
  return fetched ?? stored ?? null
}
